export default "__VITE_ASSET__FpP2TKIp__"